module.exports = __webpack_public_path__ + "img/sbp.6de6081a.svg";